import React, { useContext, useEffect, useState } from "react";
export const AppContext = React.createContext({});
export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }: any) => {
  const [usersData, setUserData] = useState<any>(() => {
    const savedData = sessionStorage.getItem("loginData");
    return savedData ? JSON.parse(savedData) : {};
  });
  const [resumeData, setResumeData] = useState<any>({
    fullName: 'Diya Agarwal',
    email: 'd.agarwal@sample.in',
    phone: '+91 11 5555 3345',
    address: 'New Delhi, India 110034',
    photoUrl: 'https://storage.googleapis.com/a1aa/image/cf7c73ad-a13f-4fb5-1d74-5758dafc7b5e.jpg',
    
    objective: 'Customer-focused Retail Sales professional with solid understanding of retail dynamics, marketing and customer service. Offering 5 years of experience providing quality product recommendations and solutions to meet customer needs and exceed expectations. Demonstrated record of exceeding revenue targets by leveraging communication skills and sales expertise.',
    
    companyName: 'ZARA',
    jobTitle: 'Retail Sales Associate',
    jobDates: 'February 2017 - Current',
    jobDescription: 'Increased monthly sales 10% by effectively upselling and cross-selling products to maximize profitability\nPrevented store losses by leveraging awareness, attention to detail, and integrity to identify and investigate concerns.\nProcessed payments and maintained accurate drawers to meet financial targets.',
    
    ugDegree: 'B.Com (Hons)',
    ugCGPA: '8.2',
    ugYear: '2023',
    twelveBoard: 'CBSE',
    twelvePercent: '91%',
    twelveYear: '2020',
    tenBoard: 'CBSE',
    tenPercent: '93%',
    tenYear: '2018',
    
    skills: 'Cash register operation\nPOS system operation\nSales expertise\nTeamwork\nInventory management\nAccurate money handling\nDocumentation and recordkeeping\nRetail merchandising expertise',
    interest1: 'Team captain\nTwo-time league champions',
    interest2: 'Taught classes in lifesaving skills including: CPR, First Aid',
    languages: 'Hindi:native\nEnglish:proficient\nBengali:intermediate',
    nativeLanguage: 'Hindi'
  });

  // Current step state (1, 2, or 3)
  const [currentStep, setCurrentStep] = useState<number>(1);
  
  // Theme/accent color state - default is orange
  const [accentColor, setAccentColor] = useState<string>('#f26e50');
  const [accentGradient, setAccentGradient] = useState<string>('linear-gradient(90deg, #e45a33 0%, #f26e50 100%)');

  // Update resume data function
  const updateResumeData = (field: any, value: string) => {
    setResumeData((prev:any) => ({
      ...prev,
      [field]: value
    }));
  };

  // Create the context value
  const contextValue: any = {
    resumeData,
    updateResumeData,
    currentStep,
    setCurrentStep,
    accentColor,
    setAccentColor,
    accentGradient,
    setAccentGradient
  };
  let loaderElement: any;
  let count: number = 0;
  const showLoader = () => {
    if (!count) {
      loaderElement = document?.getElementById("loader-block");
      loaderElement.style.display = "block";
    }
    count++;
  };
  const hideLoader = () => {
    count--;
    if (!count) {
      setTimeout(() => {
        loaderElement = document?.getElementById("loader-block");
        loaderElement.style.display = "none";
      }, 0);
    }
  };
  const handleLogin = (data: any) => {
    setUserData(data);
    sessionStorage.setItem("loginData", JSON.stringify(data));
    sessionStorage.setItem("token", data.token);
  };

  return (
    <AppContext.Provider value={{ showLoader, hideLoader,handleLogin,usersData,contextValue }}>
      {" "}
      {children}
    </AppContext.Provider>
  );
};
